<template>
  <StandardCardPageContainer>
    <template #title>Supplier Overview</template>
    <LoadingCircle v-if="suppliersStore.loading"></LoadingCircle>
    <div v-else>
      <SupplierOverview
        :can-upload-business-partner="senderStore.canSendToBP"
        :suppliers="suppliers"
        @supplier-list-changed="getUpdatedSupplierList"
      />
    </div>
  </StandardCardPageContainer>
</template>

<script setup lang="ts">
import StandardCardPageContainer from "@/components/containers/StandardCardPageContainer.vue";
import { useAuthenticationStore } from "@/stores/authentication";
import { useSenderStore } from "@/stores/sender";
import SupplierOverview from "@/views/supplier-registry/SupplierOverview.vue";
import { computed, onBeforeMount, ref } from "vue";
import { useSuppliersStore } from "@/stores/suppliersStore";
import { useSnackBarStore } from "@/stores/snackBarStore";
import LoadingCircle from "@/components/custom/LoadingCircle.vue";

const senderStore = useSenderStore();
const authenticationStore = useAuthenticationStore();
const suppliersStore = useSuppliersStore();
const snackBarStore = useSnackBarStore();

const suppliers = computed(() => suppliersStore.suppliers);

onBeforeMount(async () => {
  senderStore.canSendToBP = authenticationStore.canUploadBusinessPartners();
});

async function getUpdatedSupplierList() {
  try {
    await suppliersStore.setSupplierList();
  } catch (error: any) {
    snackBarStore.showError(error.message);
  }
}
</script>
